import $axios from '../services/api.js'

const state = () => ({
    categories: [],
    page: 1
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.categories = payload
    },

    SET_PAGE(state, payload) {
        state.page = payload
    },
}

const actions = {
    getCategory({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/category`)
                .then((response) => {
                    commit('ASSIGN_DATA', response.data.data)
                    resolve(response.data)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}